import {Component, OnInit} from '@angular/core';
import {BootstrapService} from '@app/bootstrap.service';

@Component({
    selector: 'siq-app-root',
    template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
    constructor(private bootstrap: BootstrapService) {}

    async ngOnInit(): Promise<void> {
        await this.bootstrap.bootstrap();
    }
}
